export type ScreenAction =
  | { type: 'SCREEN_RESIZE', width: number };

export const screenResize = (width: number): ScreenAction => ({
  width,
  type: 'SCREEN_RESIZE',
});


// WEBPACK FOOTER //
// ./src/store/Screen/actions.tsx